// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__22o-M","item":"PaymentsMobile_item__2ov5b","label":"PaymentsMobile_label__3U9WE","amount":"PaymentsMobile_amount__3LKMJ"};